import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart } from '../../../shared';
import { WORST_REACH_CHART_OPTIONS } from './constants';

const WorstCTRChart = () => {
    const { company } = useSelector((state) => state.company) || {};
    const { dtcData } = useSelector((state) => state.paidSearch);
    const { isPaidSearchLoading, worstCTRChart } = dtcData;
    const { categories, data } = worstCTRChart;
    const barChartOptions = useMemo(
        () => ({
            ...WORST_REACH_CHART_OPTIONS,
            xaxis: {
                ...WORST_REACH_CHART_OPTIONS.xaxis,
                categories: categories,
            },
            plotOptions: {
                ...WORST_REACH_CHART_OPTIONS.plotOptions,
                bar: {
                    ...WORST_REACH_CHART_OPTIONS.plotOptions.bar,
                    barHeight: categories.length === 1 ? 45 : '100%',
                },
            },
            tooltip: {
                enabled: true,
                marker: { show: false },
                custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                    const item = data[dataPointIndex];
                    return `<div style="padding: 8px; background: white; border-radius: 4px; box-shadow: 0px 0px 4px rgba(0,0,0,0.2);">
                            <p style="margin: 0; font-size: 14px; font-weight: bold;">${w.globals.labels[dataPointIndex]}</p>
                            <p style="margin: 0;">CTR: <span style="font-weight: bold;">${item.totalPercentage}%</span></p>
                        </div>`;
                },
            },
        }),
        [categories, data],
    );

    const [key, setKey] = useState(0);

    useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [company]);
    const chartSeries = useMemo(
        () => [
            {
                name: '',
                data: data.map((item) => item.totalPercentage), // Only numbers
            },
        ],
        [data],
    );
    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                    Least Performing Keywords by CTR
                </Typography>
                <Typography
                    className="text-sm-regular gray-500"
                    sx={{ marginTop: '4px' }}
                >
                    * Minimum 200 Impressions
                </Typography>
            </Box>

            <Box className="wh-100" id="engagement-deciles">
                {isPaidSearchLoading ? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : (
                    <BarChart
                        chartOptions={barChartOptions}
                        chartSeries={chartSeries}
                        height={'300px'}
                        key={key}
                    />
                )}
            </Box>
        </Box>
    );
};

export default WorstCTRChart;
